import { DatePipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    imports: [DatePipe],
    template: `
        <div class="layout-footer">
            <div class="footer-datetime" aria-label="Current UTC time">
                <i class="pi pi-clock"></i>
                <span>{{ currentDate | date: "EEEE, MMMM d y HH:mm:ss '(UTC)'" : 'UTC' }}</span>
            </div>
            <span class="footer-copyright">&#169; {{ currentDate | date: 'y' : 'UTC' }} IDP. All rights reserved.</span>
        </div>
    `
})
export class AppFooter implements OnDestroy {
    currentDate = new Date();

    private readonly clockTimer = window.setInterval(() => {
        this.currentDate = new Date();
    }, 1000);

    ngOnDestroy() {
        window.clearInterval(this.clockTimer);
    }
}
